import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { api } from '../../api/client'

export default function InquiryFollowups({companyId,inquiryId}:{companyId:string;inquiryId:string}) {
  const [open,setOpen]=useState(false)
  const [data,setData]=useState<Awaited<ReturnType<typeof api.inquiryFollowups>>|null>(null)
  const [error,setError]=useState('')
  const [attempt,setAttempt]=useState(0)
  useEffect(()=>{
    if(!open)return
    let live=true
    let timer:number|undefined
    const refresh=async()=>{
      try { const result=await api.inquiryFollowups(companyId,inquiryId);if(live){setData(result);setError('')} }
      catch(e){if(live)setError(e instanceof Error?e.message:'Could not load inquiry follow-ups')}
      finally{if(live)timer=window.setTimeout(refresh,5000)}
    }
    void refresh()
    return()=>{live=false;window.clearTimeout(timer)}
  },[companyId,inquiryId,open,attempt])
  return <details onToggle={event=>setOpen(event.currentTarget.open)}><summary>Follow-ups for this inquiry</summary>
    {error && <p className="notice crit" role="alert">{error}</p>}
    {!data && open && !error && <p className="muted">Loading inquiry follow-ups…</p>}
    {data && <>
      <p className="muted">Automatic {data.channel==='web_form'?'website-form ':data.channel==='email'?'email ':''}follow-ups are {data.enabled?'enabled':'disabled'}. Global outbound is {data.outbound_enabled?'enabled':'paused'}.</p>
      <p className="muted">Scheduled work waits for its due date and eligible controls. Queued or held work has not been delivered. {data.channel==='web_form'?'Submitted records browser confirmation of the form submission.':'Sent records the email service accepting the message.'} Neither confirms that a person received or read it.</p>
      {!data.rows.length && <p className="muted">No follow-ups are linked to this inquiry. Older company reminders are not assigned here automatically.</p>}
      <ul className="form-steps">{data.rows.map(row=><li key={row.id}><strong>Day {row.day} · {row.status.replace(/_/g,' ')}</strong><p>Due {new Date(row.due_at).toLocaleString()}</p>{row.hold_reason && <p className="notice">Not ready: {row.hold_reason}</p>}{row.job && <><p className="muted">Workflow: {row.job.status.replace(/_/g,' ')} · {row.job.stage.replace(/_/g,' ')}</p>{row.job.error && <p className="workflow-error">{row.job.error}</p>}</>}</li>)}</ul>
      {!!data.rows.length && <Link to="/app/workflows">View workflows</Link>}
    </>}
    {error && <button className="btn secondary small" onClick={()=>{setError('');setAttempt(value=>value+1)}}>Retry follow-ups</button>}
  </details>
}
